import { defineAsyncComponent } from 'vue';

const TextField = defineAsyncComponent(() => import('@maison/components/form/fields/TextField.vue'));
const SelectField = defineAsyncComponent(() => import('@maison/components/form/fields/SelectField.vue'));
const RadioListField = defineAsyncComponent(() => import('@maison/components/form/fields/RadioListField.vue'));
const PhoneField = defineAsyncComponent(() => import('@maison/components/form/fields/PhoneField.vue'));
const TextareaField = defineAsyncComponent(() => import('@maison/components/form/fields/TextareaField.vue'));
const CheckboxField = defineAsyncComponent(() => import('@maison/components/form/fields/CheckboxField'));
const AudioRecordingField = defineAsyncComponent(() => import('@maison/components/form/fields/AudioRecordingField'));
const DatePickerField = defineAsyncComponent(() => import('@maison/components/form/fields/DatePickerField.vue'));
const CheckboxListField = defineAsyncComponent(() => import('@maison/components/form/fields/CheckboxListField.vue'));
const CustomTextField = defineAsyncComponent(() => import('@maison/components/form/fields/CustomTextField.vue'));
const PasswordField = defineAsyncComponent(() => import('@maison/components/form/fields/PasswordField.vue'));

export function getFieldComponentForType(type) {
  switch (type) {
    case 'select':
      return SelectField;
    case 'radio':
      return RadioListField;
    case 'checkbox':
      return CheckboxField;
    case 'phone':
      return PhoneField;
    case 'textarea':
      return TextareaField;
    case 'audioRecording':
      return AudioRecordingField;
    case 'date':
      return DatePickerField;
    case 'checkboxList':
      return CheckboxListField;
    case 'customText':
      return CustomTextField;
    case 'password':
      return PasswordField;
    default:
      return TextField;
  }
}
